/**
 * Funktionen je Watchface für den Abschnitt „Bedienung & Anzeige“.
 * Texte: features.items.<id>.title und features.items.<id>.<variante> (Standard: "text").
 * Ausführliche Erklärungen stehen in den Anleitungen (guide), nicht auf der Produktseite.
 */
export const featureDefs = {
    longPress: { guide: '/guides/touch', requires: ['touch'] },
    openApps: { guide: '/guides/touch#open-apps', requires: ['touch'] },
    switchview: { guide: '/guides/switchviews' },
    alternateSet: { guide: '/guides/switchviews#alternate' },
    watchMenu: { guide: '/guides/watch-menu', requires: ['ciq42'] },
    displayModes: { guide: '/guides/display-modes' },
    handsMove: { guide: '/guides/display-modes#hands', requires: ['crossover'] },
    forecast: { guide: '/guides/weather#forecast' },
};
export const productFeatures = {
    basicpro: [['longPress', 'fullNoSwitch'], 'openApps', 'watchMenu', 'displayModes'],
    nevada: [['longPress', 'timeNoSwitch'], 'openApps', 'watchMenu', 'displayModes', 'handsMove'],
    tactical: [['longPress', 'tactical'], 'openApps', ['switchview', 'tactical'], ['alternateSet', 'tactical'], 'forecast', 'watchMenu', ['displayModes', 'noMip']],
    senator: [['longPress', 'full'], 'openApps', 'switchview', ['alternateSet', 'senator'], 'forecast', 'watchMenu', 'displayModes', 'handsMove'],
    tomahawk: [['longPress', 'full'], 'openApps', 'switchview', 'forecast', 'watchMenu', ['displayModes', 'noMip'], 'handsMove'],
    fletcher: [['longPress', 'time'], 'openApps', ['alternateSet', 'six'], 'watchMenu', 'displayModes', 'handsMove'],
    iozen: ['openApps', 'watchMenu', ['displayModes', 'fixed']],
    vanguard: [['longPress', 'full'], 'openApps', 'switchview', 'forecast', 'watchMenu', 'displayModes'],
    nightfever: [['longPress', 'time'], 'openApps', ['alternateSet', 'six'], 'watchMenu', ['displayModes', 'fixed'], 'handsMove'],
    blackhawk: [['longPress', 'leftIcons'], 'openApps', 'switchview', 'forecast', 'watchMenu', 'displayModes'],
    zero: [['longPress', 'leftIcons'], 'openApps', 'switchview', 'forecast', 'watchMenu', 'displayModes'],
};
export function featuresFor(slug) {
    return (productFeatures[slug] || []).map((e) => (Array.isArray(e) ? { id: e[0], variant: e[1] } : { id: e, variant: 'text' }));
}
